import { css } from 'styled-components';
import { StyledTheme } from '../../../../styles';

export const SelectInputInvalidStyles = css<{ theme: StyledTheme }>`
  label {
    color: ${({ theme }) => theme.palette.primaryTextColor};
  }

  select {
    cursor: pointer;
    color: ${({ theme }) => theme.palette.primaryTextColor};
  }

  select > option {
    color: ${({ theme }) => theme.palette.primaryHoverTextColor};
  }

  select:hover {
    color: ${({ theme }) => theme.palette.primaryHoverTextColor};
  }

  select:focus {
    color: ${({ theme }) => theme.palette.primaryHoverTextColor};
  }
`;
